import { View } from 'foundations-components/transitional/components/View';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { H3 } from 'foundations-components/transitional/components/H3';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import { Text } from 'foundations-components/components/Text';
import { PortalMessage, usePortalTranslations } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MESSAGE_KEY = 'REFERENCE_SPACE_EXAMPLE';
const FALLBACK = `(no translation saved for ${MESSAGE_KEY})`;
export function TranslationsExample() {
  const {
    portalText,
    loading
  } = usePortalTranslations();
  const hookValue = portalText(MESSAGE_KEY);
  return /*#__PURE__*/_jsxs(View, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: "Translations Example"
    }), /*#__PURE__*/_jsxs(Paragraph, {
      children: ["Renders the ", /*#__PURE__*/_jsx("code", {
        children: MESSAGE_KEY
      }), " portal translation using the Portal Translations primitives from portals-platform-lib. If no value has been saved for this key on the current portal instance, the fallback is shown instead."]
    }), /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-300",
            children: "PortalMessage component"
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(PortalMessage, {
            messageKey: MESSAGE_KEY,
            fallback: FALLBACK
          })
        })]
      })
    }), /*#__PURE__*/_jsx(CardWrapper, {
      children: /*#__PURE__*/_jsxs(CardSection, {
        children: [/*#__PURE__*/_jsx(Paragraph, {
          children: /*#__PURE__*/_jsx(Text, {
            typography: "heading-300",
            children: "usePortalTranslations hook"
          })
        }), /*#__PURE__*/_jsx(Paragraph, {
          children: loading ? 'Loading translations…' : hookValue !== null && hookValue !== void 0 ? hookValue : FALLBACK
        })]
      })
    })]
  });
}